import { useLocation, useNavigate } from '@tanstack/react-router';
import styled from 'styled-components';

import { Tabs } from '@creditornot/cb-tabs';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { media } from 'common/media';

const TabsContainer = styled.div`
  margin: 0 -16px;
  flex-shrink: 0;
  @media ${media.sm} {
    margin: 0 -24px;
  }
`;
const TABS = ['vendors', 'fundings'] as const;

export function VendorsTabs() {
  const navigate = useNavigate();
  const formatMessage = useFormatMessage();
  const location = useLocation();

  const activeTabId = TABS.find((tab) => location.pathname.endsWith(tab)) || TABS[0];

  return (
    <TabsContainer>
      <Tabs
        activeTabId={activeTabId}
        onChange={(tab) => {
          void navigate({
            to: tab === 'vendors' ? '/vendors' : `/vendors/${tab}`,
            search: {},
            params: {},
            replace: true,
          });
        }}
        items={TABS.map((tab) => ({
          id: tab,
          label:
            tab === 'fundings'
              ? formatMessage(`vendor_fundings.fundings`)
              : formatMessage('common.vendors'),
        }))}
      />
    </TabsContainer>
  );
}
